import { CHAIN_NAMES, ChainName } from '@ui/types/chain';
import { uniq } from 'lodash-es';

const erc20TokensByChain = {
  [ChainName.MONAD_TESTNET]: [
    'USDC',
    'WMON',
    'WRAPPED_NATIVE',
    'LVUSD',
    'LVMON',
    'sLVMON',
    'LV',
    'Rona',
    'xLV',
    'sxLV',
    'yLV',
  ] as const,
  [ChainName.MONAD]: [
    'USDC',
    'WMON',
    'WRAPPED_NATIVE',
    'LVUSD',
    'LVMON',
    'sLVMON',
    'LV',
    'Rona',
    'EMO',
    'xLV',
    'sxLV',
    'yLV',
  ] as const,
} satisfies Record<ChainName, string[]>;

export const erc20Tokens = uniq(
  CHAIN_NAMES.flatMap((v) => {
    return erc20TokensByChain[v];
  }),
);

const nativeTokensByChain = {
  [ChainName.MONAD_TESTNET]: 'MON' as const,
  [ChainName.MONAD]: 'MON' as const,
} satisfies Record<ChainName, string>;

const nativeTokens = CHAIN_NAMES.map((chain) => nativeTokensByChain[chain]);

const baseTokens = [
  ...nativeTokens,
  'BTC' as const,
  'MON' as const,
  'ETH' as const,
  'SOL' as const,
];

const poolTokensByChain = {
  [ChainName.MONAD_TESTNET]: [
    'WMON',
    'USDC',
    'MON',
    'LVUSD',
    'LVMON',
    'LV',
    'Rona',
  ] as const,
  [ChainName.MONAD]: ['WMON', 'USDC', 'MON', 'LVUSD', 'LVMON', 'LV', 'EMO'] as const,
} satisfies Record<ChainName, (ERC20TokenSymbol | NativeTokenSymbol)[]>;

export const poolTokens = uniq(
  CHAIN_NAMES.flatMap((v) => {
    return poolTokensByChain[v];
  }),
);

const tokens = [
  ...erc20Tokens,
  ...nativeTokens,
  ...poolTokens,
  ...baseTokens,
] as const;
export type PoolTokenSymbol = (typeof poolTokens)[number];
export type TokenSymbol = (typeof tokens)[number];
export type PayTokenSymbol = PoolTokenSymbol | NativeTokenSymbol;
export type NativeTokenSymbol = (typeof nativeTokens)[number];
export type BaseTokensSymbol = (typeof baseTokens)[number];
export type ERC20TokenSymbol = (typeof erc20Tokens)[number];

export type ChainTokens = (typeof erc20TokensByChain)[ChainName.MONAD][number];

export const getIsTokenSymbol = (symbol: string): symbol is TokenSymbol => {
  return tokens.includes(symbol as any);
};

export const getIsErc20Symbol = (
  symbol: string,
): symbol is ERC20TokenSymbol => {
  return erc20Tokens.includes(symbol as any);
};

export const getIsNativeSymbol = (
  symbol: string,
): symbol is NativeTokenSymbol => {
  return nativeTokens.includes(symbol as any);
};
